@if ((isCarrierConnect$ | async) === false) {
  <fcom-notification>{{ 'MMB.checkIn.kyt.notification' | finLocalization }}</fcom-notification>
} @else {
  <fcom-notification>{{ 'MMB.checkIn.kyt.carrierConnectNotification' | finLocalization }}</fcom-notification>
}

<fin-included-products
  class="block mr-xsmall-t ms-xlarge-b"
  *ngIf="(services$ | async)?.length"
  [showHeading]="false"
  [servicesToShow]="services$ | async"
  [booking]="order$ | async"
  [bound]="bound$ | async"
  [includeSeatActionButtons]="includeSeatActionButtons$ | async"
  [showClearPendingSeatsButton]="hasPendingSeats"
  [isCarrierConnect]="isCarrierConnect$ | async"
  [includeAssignAtAirportStatus]="true"
  [showNonAYSeats]="true"
  (clearPendingSeats)="clearPendingSeats.emit()"
  (viewSeatmap)="viewSeatmap.emit()"
></fin-included-products>
<fcom-cta-button
  *finLet="ctaAction$ | async as ctaAction"
  [visible]="true"
  [title]="ctaAction.key | finLocalization"
  [position]="ButtonPosition.GRID_FULL"
  [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
  (buttonClicked)="continue()"
>
  <span class="gray-50-text">{{ 'subtotal' | finLocalization }}: </span>
  <span data-testid="price-amount" class="font-body-1">{{ totalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
</fcom-cta-button>
